'use strict';

var chunkNF5D6XOQ_js = require('../chunk-NF5D6XOQ.js');
require('../chunk-JOML6I2W.js');



Object.defineProperty(exports, 'LiteEvent', {
	enumerable: true,
	get: function () { return chunkNF5D6XOQ_js.a; }
});
